export default __webpack_public_path__ + "simple-map-800-6400deef0085aa715822a160e2d719ec.png";